import { useQueryState } from 'nuqs'
import { searchParamsParsers } from '#app/utils/search-params'
import { Toggle } from './shared/toggle/toggle'

export function CustomizeIconName() {
	const [iconName, setIconName] = useQueryState(
		'iconName',
		searchParamsParsers.iconName,
	)

	return (
		<div className="flex items-center justify-between gap-2">
			<h2 className="text-primary text-sm font-semibold">Icon Name</h2>

			<Toggle
				aria-label="Icon Name"
				isSelected={iconName === 'true'}
				onChange={(isSelected) => {
					void setIconName(isSelected ? 'true' : 'false')
				}}
			/>
		</div>
	)
}
